import React from "react";
import Layout from "../layout/Layout";
import { Button, Card, Col, Flex, Row, Typography } from "antd";
import { RollbackOutlined } from "@ant-design/icons";
const { Title, Text } = Typography;

const QAQCLaboritoryMenu = ({ history }) => {
	const showCylinderTesting = () => {
		history.push("/qc/job/cylindertesting");
	};

	const showCustomerTest = () => {
		history.push("/qc/job/customertest");
	};

	const CustomDashboard = () => {
		return (
			<div>
				<Row gutter={16}>
					<Col span={12}>
						<Card
							bordered
							style={{ backgroundColor: "#16207cff", cursor: "pointer" }}
							onClick={showCylinderTesting}
						>
							<Flex align="center" justify="center" vertical>
								<Title level={2} style={{ color: "white" }}>
									Compressive Stength Test
								</Title>
								<Text style={{ color: "white" }}>QA/QC Dashboard</Text>
							</Flex>
						</Card>
					</Col>

					{/* <Col span={12}>
						<Card
							bordered
							style={{ backgroundColor: "#3533b6ff", cursor: "pointer" }}
							onClick={showCustomerTest}
						>
							<Flex align="center" justify="center" vertical>
								<Title level={2} style={{ color: "white" }}>
									Customer Test Reports
								</Title>
								<Text style={{ color: "white" }}>QA/QC Report</Text>
							</Flex>
						</Card>
					</Col> */}
				</Row>
			</div>
		);
	};

	const goBack = () => {
		history.goBack();
	};

	return (
		<Layout title="QA/QC Test Reports" description="Menu">
			<Flex vertical gap={16}>
				<Button
					type="primary"
					size="large"
					icon={<RollbackOutlined />}
					onClick={goBack}
				/>
				<CustomDashboard />
			</Flex>
		</Layout>
	);
};

export default QAQCLaboritoryMenu;
